import { useStore } from 'vuex';
import xapi from '../../../services/xapi';

/**
 * Composable for retrieving discovery page data.
 *
 * @description
 * This composable is used to get data from the discoveryStore getters.
 *
 * @returns {Object} An object containing the `loadPage` function for fetching data
 */

// Load page data from the xapi service and dispatch it to the store.
// options.isActive() can be used to avoid dispatching after unmount (e.g. in embed).
const loadPage = (store) => async (pageInformation, options = {}) => {
  const { canvasData, pagination } = await xapi.loadDiscoveryPage(pageInformation);
  if (typeof options.isActive === 'function' && !options.isActive()) {
    return;
  }
  const payload = canvasData?.data ?? canvasData;
  if (!payload?.body) {
    return;
  }
  const toSet = {
    ...payload,
    redirect: payload.redirect ?? null,
    pagination: payload.pagination ?? pagination,
  };
  store.dispatch('SET_PAGE', toSet);
};

export default function useDiscovery() {
  return {
    loadPage: loadPage(useStore()),
  };
}
